import classNames from 'classnames';
import React from 'react';
import { Checkbox, InfoText, MoreLink, InfoIconWithPopover } from 'wix-rich-content-ui-components';
import { s as styles } from '../../link-panel-4ec20ca9.js';
import { learMoreUrl } from './consts.js';
import '../../style-inject.es-746bb8ed.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const AdvancedCheckboxes = ({
  checkboxesData,
  useAdvancedSettings,
  isMobile,
  t,
  langDir
}) => {
  const [checkboxFocused, setCheckboxFocused] = React.useState(false);
  const [clickFromMouse, setClickFromMouse] = React.useState(false);
  const tooltipVisibilityProps = (index) => ({
    onMouseDown: () => setClickFromMouse(true),
    onKeyDown: (e) => {
      if (e.key === "Tab" || e.shiftKey && e.key === "Tab") {
        setClickFromMouse(false);
      }
    },
    onFocus: () => setCheckboxFocused(index),
    onBlur: () => setCheckboxFocused(false)
  });
  return /* @__PURE__ */ React.createElement(React.Fragment, null, checkboxesData.map(
    (checkbox, index) => checkbox.showCheckbox && /* @__PURE__ */ React.createElement(
      "div",
      __spreadValues({
        key: checkbox.dataHook,
        className: classNames(styles.linkPanel_checkbox, {
          [styles.linkPanel_advanced_checkbox]: useAdvancedSettings,
          [styles.linkPanel_advanced_checkbox_mobile]: useAdvancedSettings && isMobile
        })
      }, tooltipVisibilityProps(index)),
      /* @__PURE__ */ React.createElement(
        Checkbox,
        {
          label: checkbox.label,
          checked: checkbox.checked,
          dataHook: checkbox.dataHook,
          onChange: checkbox.onChange,
          tooltipTextKey: useAdvancedSettings ? void 0 : checkbox.tooltipTextKey,
          forceTooltipVisibility: !clickFromMouse && checkboxFocused === index,
          t,
          isMobile
        }
      ),
      isMobile && useAdvancedSettings ? /* @__PURE__ */ React.createElement(InfoText, { style: { marginLeft: 30, marginBottom: 8 } }, /* @__PURE__ */ React.createElement(React.Fragment, null, t(checkbox.tooltipTextKey), " ", /* @__PURE__ */ React.createElement(MoreLink, { link: learMoreUrl, t }))) : useAdvancedSettings && !isMobile ? /* @__PURE__ */ React.createElement(
        InfoIconWithPopover,
        {
          forceVisibility: !clickFromMouse && checkboxFocused === index,
          langDir
        },
        /* @__PURE__ */ React.createElement(React.Fragment, null, t(checkbox.tooltipTextKey), " ", /* @__PURE__ */ React.createElement(MoreLink, { link: learMoreUrl, t }))
      ) : null
    )
  ));
};

export { AdvancedCheckboxes as default };
//# sourceMappingURL=AdvancedCheckboxes.js.map
